import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, FormControl,
  FormControlLabel,
  FormLabel, Radio,
  RadioGroup,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState } from 'react';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { sendAmbassadorInvitationAction } from 'src/redux/actions/ambassadorActions';
import { AmbassadorInvitationPayload } from 'src/models/FundraisingModel';

const SendAmbassadorInviteDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.sendAmbassadorInvitation]) {
        return state.dialog[DIALOGS.sendAmbassadorInvitation];
      }
      return { opened: false, payload: {} as AmbassadorInvitationPayload };
    });
  const selected = useSelector((state: Store) => state.selected[ENTITIES.ambassadors]);
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const [sendTo, setSendTo] = useState('selected');
  const [sendBy, setSendBy] = useState('email');

  const { data, fundraisingId } = payload;

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.sendAmbassadorInvitation }));
  };

  const handleOk = () => {
    // Send invitation action here
    switch (sendTo) {
      case 'selected':
        dispatch(sendAmbassadorInvitationAction(
          fundraisingId,
          {
            emailSent: false,
            smsSent: false,
            filter: '',
            selected,
            all: false,
            delivery: sendBy,
          } as AmbassadorInvitationPayload,
        ));
        break;
      case 'all':
        dispatch(sendAmbassadorInvitationAction(
          fundraisingId,
          {
            emailSent: false,
            smsSent: false,
            filter: '',
            selected: [],
            all: true,
            delivery: sendBy,
          } as AmbassadorInvitationPayload,
        ));
        break;
      case 'displayed':
        dispatch(sendAmbassadorInvitationAction(
          fundraisingId,
          {
            ...data,
            selected: [],
            all: true,
            delivery: sendBy,
          } as AmbassadorInvitationPayload,
        ));
        break;
      default:
    }

    dispatch(closeDialog({ dialog: DIALOGS.sendAmbassadorInvitation }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="send-ambassador-invitatation"
      open={opened}>
      <DialogTitle id="send-ambassador-invitatation">Send Invitation to Ambasador(s)</DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">Send to</FormLabel>
          <RadioGroup
            row
            aria-label="format"
            name="format"
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}>
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="displayed" control={<Radio />} label="Displayed" />
            <FormControlLabel value="selected" control={<Radio />} label="Selected" />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">Send By</FormLabel>
          <RadioGroup
            row
            aria-label="format"
            name="format"
            value={sendBy}
            onChange={(e) => setSendBy(e.target.value)}>
            <FormControlLabel value="email" control={<Radio />} label="Email" />
            <FormControlLabel value="sms" control={<Radio />} label="SMS" />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendAmbassadorInviteDialog;
